import "./style.scss";
import { FC } from "react";
import FormSuccessSvg from "@/src/svg/FormSuccessSvg";

interface IFormSuccess {
  stateFormSuccess: boolean;
  setStateFormSuccess: (val: boolean) => void;
}

const FormSuccess: FC<IFormSuccess> = ({ stateFormSuccess, setStateFormSuccess }) => {
  const handleClose = () => {
    setStateFormSuccess(false);
  };

  return (
    <>
      {stateFormSuccess && (
        <div className="form-success">
          <div className="form-success-content">
            <div className="form-success-svg">
              <FormSuccessSvg />
            </div>
            <div className="form-success-subtitle">
              <p>Номер вашей заявки U25-03-000002</p>
            </div>
            <div className="form-success-title">
              <p>Успешно отправлена</p>
            </div>
            <button className="form-success-button" onClick={handleClose}>
              Вернуться к сайту →
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FormSuccess;
